import { render } from "./User_profile.vue?vue&type=template&id=f11f271a&scoped=true"
import script from "./User_profile.vue?vue&type=script&lang=js"
export * from "./User_profile.vue?vue&type=script&lang=js"

import "./User_profile.vue?vue&type=style&index=0&id=f11f271a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f11f271a"]])

export default __exports__